/**
 * 模型管理 API
 * 处理模型列表查询和用户模型偏好的增删改查
 */

import instance from './request';
import type { ApiResponse, ModelPreferences, ModelsListData } from '@ai-video/shared';

// 从 shared 包重新导出类型，保持现有导入路径兼容
export type { ModelConfig, ModelPreferences, ModelsListData, ImageModelParams, VideoModelParams } from '@ai-video/shared';

// 从 shared 包导出视频积分计算函数
export { calculateVideoCreditsCost, getVideoCostPerSecond, VIDEO_CREDITS_RULES } from '@ai-video/shared';

// ============================================
// API 方法
// ============================================

/**
 * 获取可用模型列表
 * @returns 图片模型和视频模型列表（仅启用的）
 */
export const getModels = async (): Promise<ApiResponse<ModelsListData>> => {
  const response = await instance.get<ApiResponse<ModelsListData>>('/models');
  return response;
};

/**
 * 获取用户模型偏好
 * @returns 用户当前的模型偏好设置
 */
export const getModelPreferences = async (): Promise<ApiResponse<ModelPreferences>> => {
  const response = await instance.get<ApiResponse<ModelPreferences>>('/user/model-preferences');
  return response;
};

/**
 * 更新用户模型偏好
 * @param data 偏好更新数据
 * @returns 更新后的偏好设置
 */
export const updateModelPreferences = async (data: Partial<ModelPreferences>): Promise<ApiResponse<ModelPreferences>> => {
  const response = await instance.put<ApiResponse<ModelPreferences>>('/user/model-preferences', data);
  return response;
};
